import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { selectConnectedForms } from '../../../selectors/connectedForms';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { useMemo } from 'react';
import { useAppSelector } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const TranslateTemplateFieldGroupLabel = styled.span.withConfig({
  displayName: "TranslateTemplateUISelectGroup__TranslateTemplateFieldGroupLabel",
  componentId: "sc-108puak-0"
})(["font-size:16px;font-weight:600;"]);
export default function TranslateTemplateUISelectGroup(props) {
  const connectedForms = useAppSelector(selectConnectedForms);
  const connectedFormOptions = useMemo(() => [{
    //Resolving CG-50418 - allows removing support form ID from variants
    text: 'No form selected',
    value: ''
  }, ...connectedForms.map(form => ({
    text: form.name,
    value: form.guid
  }))], [connectedForms]);
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    className: "m-top-4",
    title: /*#__PURE__*/_jsx(TranslateTemplateFieldGroupLabel, {
      children: props.title
    }),
    children: props.languages.map((lang, idx) => {
      const isPrimary = idx === 0;
      const onChange = e => props.onChange(lang, e.target.value);
      const value = props.values.get(lang, '');
      return /*#__PURE__*/_jsx(UIFormControl, {
        verticalSeparation: "flush",
        label: getLanguageNameFromCode(lang),
        labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
        }) : null,
        children: /*#__PURE__*/_jsx(UISelect, {
          readOnly: isPrimary,
          onChange: onChange,
          options: connectedFormOptions,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.fieldLabels.supportSelectFormPlaceholder"
          }),
          value: value
        })
      }, lang);
    })
  });
}